import React, { forwardRef } from "react";
import { RCCSpreadsheet } from "react-common-components";
import IComponentSpreadsheet, { IRefSpreadsheet } from "react-common-components/dist/components/Spreadsheet/interface";
import { useTranslation } from "src/context/Translations/context";
import formatNumber from "src/utils/formatNumber";
import stringToNumber from "src/utils/stringToNumber";

interface ISpreadsheetScore extends Omit<IComponentSpreadsheet, "buttons">{
	actionSaveButton?: () => void;
	showButtons?: boolean;
	decimalPlaces?:number;
}

export type CellValue = string | number | boolean;

const Spreadsheet: React.ForwardRefRenderFunction<IRefSpreadsheet, ISpreadsheetScore> = ({
	actionSaveButton,
	format,
	editable,
	showButtons = true,
	decimalPlaces = 2,
	...rest
}, ref) => {
	const { translate, currentLanguage } = useTranslation();
	return (
		<RCCSpreadsheet
			ref={ref} 
			format={format && {
				columns: format.columns,
				functionToFormat: format.functionToFormat ? format.functionToFormat : (number: string | number) => formatNumber(number, currentLanguage,decimalPlaces),
				customColumnsOnReadonlyLastRows: format.customColumnsOnReadonlyLastRows
			}}
			formatTooltip={{
				stringToNumber: (val: string) => stringToNumber(val, currentLanguage),
				titleTotal: "Total",
        		titleAverage: translate("Média")
			}}
			buttons={showButtons && editable ? {
				save: {
					label: translate("Salvar"),
					action: actionSaveButton || (() => {})
				},
				cancel: {
					label: translate("Cancelar")
				}
			} : undefined}   
			editable={editable} 
			{...rest}
		/>
	);
};

export default forwardRef(Spreadsheet);
